<template>
  <div class="empty-state">
    <div class="empty-icon">
      <i :class="`fas ${icon}`"></i>
    </div>
    <h3 class="empty-title">{{ title }}</h3>
    <p class="empty-message">{{ message }}</p>
    <div class="empty-actions">
      <button 
        v-if="showResetButton" 
        class="btn btn-secondary" 
        @click="$emit('reset')"
      >
        <i class="fas fa-times"></i> Reset Search
      </button>
      <button 
        class="btn btn-primary" 
        @click="$emit('add')"
      >
        <i class="fas fa-plus"></i> Add Course URL
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: {
      type: String,
      default: 'fa-folder-open'
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    showResetButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['reset', 'add']
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  margin-bottom: 1.5rem;
}

.empty-icon {
  font-size: 3rem;
  color: #dee2e6;
  margin-bottom: 1.5rem;
  background-color: #f8f9fa;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #e9ecef;
}

.empty-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #343a40;
  margin: 0 0 0.75rem 0;
}

.empty-message {
  color: #6c757d;
  margin: 0 0 2rem 0;
  max-width: 30rem;
}

.empty-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.btn {
  padding: 0.75rem 1.25rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #3498db;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

@media (max-width: 768px) {
  .empty-state {
    padding: 3rem 1rem;
  }
  
  .empty-icon {
    font-size: 2.5rem;
    width: 5rem;
    height: 5rem;
  }
  
  .empty-title {
    font-size: 1.25rem;
  }
}
</style> 